import { render, staticRenderFns } from "./IElisaProcessing.vue?vue&type=template&id=49c67690&scoped=true&"
import script from "./IElisaProcessing.vue?vue&type=script&lang=js&"
export * from "./IElisaProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c67690",
  null
  
)

export default component.exports